module.exports = __webpack_public_path__ + "static/media/cyber-corn-overlords.e0bda06c.png";